import { AccountingLogService } from "@fs/services/accounting-log";
import { ActionName } from "@shared/enums/action-name";

import { AuthService } from "@services/auth.service";
import { CommonMethods } from "@services/common.method";
import { CommonService } from "@shared/services/common";
import { AfterViewInit, Component, OnInit, ViewChild, ViewContainerRef } from "@angular/core";
import { Constants } from "@shared/models/constants";
import { DataSharingLTE } from "@fs/services/data-sharing-lte";
import { DatePipe } from "@angular/common";
import {
  FormControl,
  FormGroup,
  Validators
} from "@angular/forms";
import { GridDataResult } from "@progress/kendo-angular-grid";
import { PrintService } from "@services/print-layout.service";
import { TabOpenService } from "@services/tab-open.service";
import { Tabs } from "@enums/tab.enum";
import { TimeZoneConverter } from "@shared/pipes/timezone-converter";
import { WorkOrderReviewService } from "@fs/services/work-order-review";
import { WorkOrderService } from "@fs/services/work-order";
import { NotificationsService } from "@shared/services/notification";
import { WorkTicketPaymentSummary } from "@fs/models/work-order/work-order.model";
import { PermissionPipe } from "@shared/pipes/permission";
import { WOSChangeEventDestination, PaymentType, ProductItemType } from "@fs/enums/common";
import '@shared/interfaces/number-extention';
import { WoAddPaymentComponent } from "@fs/components/common/wo-add-payment/wo-add-payment.component";
import { WoTotalPaidComponent } from "@fs/components/common/wo-total-paid/wo-total-paid.component";
import { CodeTypes } from "src/app/fs-lte/enums/code-types.enum";
import { DispatcherService } from "@fs/services/dispatcher";
import { ActionItemsModel } from "@fs/models/action-menu.model";
import { SpinnerService } from "src/app/shared/services/spinner.service";
import { TabParams } from "@fs/services/tab-params.service";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { FsUtil } from "@fs/services/fs-utils";
import { TabsComponent } from "@shared/tab/tabs/tabs.component";

declare var initBodyCustomScroll: any;

@Component({
  selector: "work-order-review-detail",
  templateUrl: "./wo-review-detail.component.html",
  styleUrls: ["./wo-review-detail.component.scss"],
  providers: [TimeZoneConverter, DatePipe]
})
export class WorkOrderReviewDetailComponent implements OnInit,AfterViewInit {
  @ViewChild("wototalPaid") wototalPaid: WoTotalPaidComponent;
  // #region  Private Variables
  private destroyTab: Boolean = false;
  private fromStatus: string = "";
  public fromSubStatus: string = "";
  private initialData: any;
  private inputParams: any;
  private math: any = Math;
  private maxValidAmount: number = 99999.99;
  public paymentTypes: any;
  private tabCounter: number;
  private _confirmationBox: boolean = false;
  private addPaymentComponent: WoAddPaymentComponent;
  private _createAgreementAlertIdx: number = -1;
  // #endregion

  // #region  Public Variables
  public isEquipmentLinkOpened : boolean = false;
  public EquipmentDialogueData : { Description: string,  WorkTicketPriceBookItemEquipments : any[],location: {x:number,y: number}} = {Description: '', WorkTicketPriceBookItemEquipments : null, location:{ x: -10000, y: -10000 }};
  public equipmentLinksPath : string = Constants.DefaultImagePaths.WorkOrderEquipmentLink;
  public actionName = ActionName;
  public activeSubTabIndex: number = 0; // by default first tab selected
  public additionalCustomerContact: any = [];
  public additionalJobSiteContact: any = [];
  public approvedPBItems: GridDataResult;
  public cancelReasonPopup: boolean = false;
  public cancelationFormGroup: FormGroup;
  public confirmActionCancelBtn: string = "";
  public confirmActionOkBtn: string = "";
  
  public confirmMessage: string = "";
  public get confirmationBox(): boolean {
    return this._confirmationBox;
  }
  public set confirmationBox(value) {
    this._confirmationBox = value;
  }
  public details: any;
  public editDisabled: boolean = false;
  public enablePostToAccounting: boolean = false;
  public invoiceDate;
  public invoiceNumber;
  public isError: boolean = false;
  public isUnsavedTriggered: boolean = false;
  public minAmount: number;
  public paymentDisabled: boolean = false;
  public postingHistory: any = [];
  public statusList = [];
  public showForChild: boolean = false;
  public showPaymentLoader: boolean = false;
  
  
  public pricebookItems: GridDataResult;
  public primaryCustomerContact: any;
  public primaryJobSiteContact: any;
  public refrenceNo = "-";
  public reviewedBy = "-";
  public showDeleteConfirmation: boolean = false;
  public showModalLoader = false;
  public showPostingToAccResult: boolean = false;
  public voidFormGroup: FormGroup;
  public voidTicketPopup: boolean = false;
  public workTicketCancelReasonLookup: any;
  public workTicketItems: any = [];
  public workTicketPaidDetails: any = [];
  public workTicketVoidReasonLookup: any;
  
  public errorShowModal: boolean = false;
  public errorMessage: string = "";
  public popupTitle: string = "";
  public estimatesConvertedTo: any;

  public attachments: GridDataResult = { data: [], total: 0 };
  public slideIndex: number = 0;
  public showAttachmentSlider: boolean = false;
  public qbVersion:string;
  public assignedTechnicians = [];
  public workTicketPayment: WorkTicketPaymentSummary;
  public hasWOReviewEditPermission: boolean = true;
  public showdropdownLoder: boolean = false;
  
  public customerAddress: string;
  public jobSiteAddress: string;
  public paymentConfirmBtnText: string = "Confirm & Pay";
  public primaryTech: any;
  public helpers = [];
  public items: ActionItemsModel[] = [
    { text: 'Undo Dispatching', disabled: !this.permissionPipe.transform(this.actionName.EditWorkOrder) }
  ];
  public get createAgreementAlertIdx() {
    return this._createAgreementAlertIdx;
  }
  public set createAgreementAlertIdx(value) {
    this._createAgreementAlertIdx = value;
    if (value > -1) {
      this.confirmationBox = true;
      this.confirmActionCancelBtn = "Cancel";
      this.confirmMessage = "This work order includes a service agreement that has not yet been created for the job site.";
      this.confirmActionOkBtn = "View";
      this.isError = false;
    }
  }
  public itemType = ProductItemType;
  private readonly ngUnsubscribe = new Subject();
  public agreementDiscount = 0;
  // #endregion

  // #region  lIFECYCLE HOOKS
  constructor(
    private accountingLogService: AccountingLogService,   
    private auth: AuthService,
    private commonMethods: CommonMethods,
    private dataSharing: DataSharingLTE,
    private datePipe: DatePipe,
    private printService: PrintService,
    private httpCommon: CommonService,
    private httpService: WorkOrderService,
    private httpWOReviewService: WorkOrderReviewService,
    private tabOpen: TabOpenService,
    private permissionPipe: PermissionPipe,    
    private toastr: NotificationsService,
    private showspinner: SpinnerService,
    private viewContainerRef: ViewContainerRef,
    private helperService: DispatcherService,
    private tabsComponent: TabsComponent
    ) {
    this.dataSharing.OrderStatusChangeEvent.pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(response => { this.details.Status = response.Status; this.details.SubStatus = response.SubStatus; });

    this.dataSharing.RefreshWoReviewForAgreement.pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(res => {
        if (res != null && this.details.ID == res.ID) {
          let index = this.details.WorkTicketPriceBookItems.findIndex(x => x.ID == res.WtPriceBookItemID);
          if (index != -1) {
            this.details.WorkTicketPriceBookItems[index].ServiceAgreementCreated = res.ServiceAgreement;
          };
          this.GetPBItems();
        }
    });
    
    this.showdropdownLoder = true;
    this.httpCommon
      .GetIntialData(
        this.auth.getCompanyId(),
        "WorkTicketCancelReasonLookup,WorkTicketVoidReasonLookup,CodeTypeData,equipmentwarrantytype,equipmentmanufacturers,equipmentcategories"
      )
      .subscribe(response => {
        this.showdropdownLoder = false;
        this.initialData = response;
        this.workTicketCancelReasonLookup = this.initialData.WorkTicketCancelReasonLookup.filter(
          x => x.IsActive == true
        );
        this.paymentTypes = response.CodeTypeData.PaymentType;
        this.workTicketVoidReasonLookup = this.initialData.WorkTicketVoidReasonLookup.filter(
          x => x.IsActive
        );
      }, error => {
        this.showdropdownLoder = false;
      });
    this.tabOpen.ConfirmDestroyTabEvent.subscribe(response => {
      if (response.tabCounter == this.tabCounter) {
        this.destroyTab = true;
        setTimeout(() => {
          this.wototalPaid.woaddPayment.SaveCommonPaymentDetail();
        }, 100);
      }
    });
    this.tabOpen.destroyModalEvent.subscribe(response => {
      if (
        
        response.tabCounter == this.tabCounter &&
        response.event == "destroy"
      ) {
        this.wototalPaid.woaddPayment.ClosePaymentModal();
        if (this.wototalPaid.woaddPayment != undefined) {
          this.tabOpen.unsavedChangedDetected({ dirty: false, Index: this.tabCounter });
          this.isUnsavedTriggered = false;
        }
      } else if (
        response.tabCounter == this.tabCounter &&
        response.event == "save"
      ) {
        setTimeout(() => {
          this.wototalPaid.woaddPayment.SaveCommonPaymentDetail();
          this.tabOpen.unsavedChangedDetected({ dirty: false, Index: this.tabCounter });
          this.isUnsavedTriggered = false;
        }, 100)
        //this.addPaymentComponent.SaveCommonPaymentDetail();
      }
    });  
    
    this.workTicketPayment = new WorkTicketPaymentSummary();
  }
  ngOnInit() {
    this.InitializeForm();
  }
  ngAfterViewInit() {
    $(".main__content_section").scrollTop(0);
  }
  ngDoCheck() {
    if (!this.isUnsavedTriggered) {
      let dirtyCreditCardForm = false;
      let dirtyPaymentForm = false;
      if (!CommonMethods.CheckNullOrUndefined(this.wototalPaid)) {
        if (!CommonMethods.CheckNullOrUndefined(this.wototalPaid.woaddPayment)) {
          dirtyCreditCardForm =
            this.wototalPaid.woaddPayment.creditCardForm != undefined &&
            this.wototalPaid.woaddPayment.creditCardForm != null &&
            this.wototalPaid.woaddPayment.creditCardForm.dirty;

          dirtyPaymentForm =
            this.wototalPaid.woaddPayment.paymentForm != undefined &&
            this.wototalPaid.woaddPayment.paymentForm != null &&
            this.wototalPaid.woaddPayment.paymentForm.dirty;
        }
      }
      
      let isDirty = dirtyCreditCardForm || dirtyPaymentForm;
      if (isDirty) {
        this.isUnsavedTriggered = true;
        this.tabOpen.unsavedChangedDetected({
          dirty: isDirty,
          Index: this.tabCounter
        });
      }
    }
  }
  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
  // #endregion

  // #region  Private Methods
  private InitializeForm(instantSpinnerTime: number = Constants.defaultSpinnertimeout, isTabRefresh: boolean = false)
  {
    this.GetWorkOrderReviewDetails(instantSpinnerTime, isTabRefresh);
    this.qbVersion = (this.auth.getCompanyQBType()).toLowerCase();      
    this.hasWOReviewEditPermission=this.permissionPipe.transform(ActionName.EditWorkOrderReview);
  }
  private IntializeCancelationFrom() {
    this.cancelationFormGroup = new FormGroup({
      CancellationReason: new FormControl("", [Validators.required]),
      CancellationComment: new FormControl("", [
        this.commonMethods.noWhitespaceValidator
      ])
    });
  }
  private IntializeVoidFrom() {
    this.voidFormGroup = new FormGroup({
      VoidReason: new FormControl("", [Validators.required]),
      VoidComment: new FormControl("", [
        this.commonMethods.noWhitespaceValidator
      ])
    });
  }
  private GetWorkOrderReviewDetails(instantSpinnerTime: number = Constants.defaultSpinnertimeout, isTabRefresh: boolean = false) {    
    this.showspinner.showloader(this.viewContainerRef, this.tabCounter, instantSpinnerTime);
    if (this.inputParams["activeSubTabIndex"] != undefined && this.inputParams["activeSubTabIndex"] != null) {
      this.activeSubTabIndex = this.inputParams["activeSubTabIndex"];
    }
    this.httpWOReviewService.GetWorkOrderReview(this.inputParams).subscribe(
      response => {
        this.details = response;
        this.GetWorkOrderAttachments(response["WorkTicketAttachments"]);
        this.showspinner.hideLoader(this.viewContainerRef, this.tabCounter);
        this.SetWorkOrderDetails(isTabRefresh);
      },
      error => {
          this.showspinner.hideLoader(this.viewContainerRef, this.tabCounter);
        if (!CommonMethods.CheckNullOrUndefined(error.error))
          this.toastr.showMultiLineError(error.error.Message, "Error");
      }
    );
    window.addEventListener(
      "message",
      function(event) {
        if (event.data != undefined && event.origin == this.window.endpointPaymentPrefix) {
          try {
            var data = JSON.parse(event.data);
            if (data.validationError == undefined) {
              $("#tokenValidationMessage").html("");
            } else {
              $("#tokenValidationMessage").html("Invalid Card Number");
            }
            $("#token").val(data.message);
          } catch (e) {}
        }
      },
      false
    );
  }

  private GetWorkOrderAttachments(attachments: any[]) {    
    if (attachments != null) {
      this.attachments.data = attachments.map(x => {
        return {
          FilePath: x.FilePath,
          Description: x.Description,
          FileName: x.FileName,
          IsImage: this.CheckIsImage(x),
          ID: x.ID,
          IsDirty: x.IsDirty,
          UploadedDate: x.CreateDate,          
          UploadedBy: x.CreatedByUser != undefined && x.CreatedByUser != null ? x.CreatedByUser["FirstName"] + " " + x.CreatedByUser["LastName"] : ""
        }
      });
      this.attachments.total = this.attachments.data.length;
    }
  }

  
  ViewAttachmentSlide(idx: number) {
    this.slideIndex = idx;
    this.showAttachmentSlider = true;
  }

  CloseAttachmentSlider() {
    this.showAttachmentSlider = false;
  }


  private CheckIsImage(dataItem) {    
    if (dataItem != null) {
      let fileName = dataItem.FileName;
      if (fileName != "") {
        let exts = ['.jpg', '.jpeg', '.gif', '.png', '.bmp'];
        return this.commonMethods.ValidExtension(fileName, exts);
      }
      else
        return false;
    }
    else
      return false;
  }

  private SetWorkOrderDetails(isTabRefresh: boolean) {
    this.fromSubStatus = this.details.SubStatus.Code.toLocaleLowerCase();
    this.fromStatus = this.details.Status.Code.toLocaleLowerCase();
    if (!CommonMethods.CheckNullOrUndefined(this.details)) {
      this.customerAddress = CommonMethods.GetCompleteAddress(this.details.Customer);
      this.jobSiteAddress = CommonMethods.GetCompleteAddress(this.details.JobSite)
    }
    if (!CommonMethods.CheckNullOrUndefined(this.details.JobSite.Contacts, true)) {
      this.primaryJobSiteContact = this.details.JobSite.Contacts.find(
        x => x.Contact.IsPrimary == true
      );
      if (CommonMethods.CheckNullOrUndefined(this.primaryJobSiteContact.Contact.LastName))
        this.primaryJobSiteContact.Contact.LastName = "";
      this.additionalJobSiteContact = this.details.JobSite.Contacts.filter(
        x => x.Contact.IsPrimary != true
      );
    } else {
      this.primaryJobSiteContact = null;
    }
    if (!CommonMethods.CheckNullOrUndefined(this.details.Customer.Contacts, true)) {
      this.primaryCustomerContact = this.details.Customer.Contacts.find(
        x => x.Contact.IsPrimary == true
      );
      if (CommonMethods.CheckNullOrUndefined(this.primaryCustomerContact.Contact.LastName))
        this.primaryCustomerContact.Contact.LastName = "";
      this.additionalCustomerContact = this.details.Customer.Contacts.filter(
        x => x.Contact.IsPrimary != true
      );
    } else {
      this.primaryCustomerContact = null;
    }
    if (!CommonMethods.CheckNullOrUndefined(this.details)) {
      this.estimatesConvertedTo = this.details.EstimatesConvertedTo.find(
        x => x.IsUsedToCreateWorkTicket == true
      );
    }
    // Primary Tech
    let appointmentTypes = this.commonMethods.getCodeTypeData(CodeTypes.AppointmentType);
    let technicianCodeTypeId = appointmentTypes.find(x=> x.Code == 'PrimaryTech').ID;

    this.primaryTech = this.details.UserAppointments.find(x => x.AppointmentTypeID == technicianCodeTypeId);
    if (!CommonMethods.CheckNullOrUndefined(this.primaryTech)) {
      let promisedDt = this.datePipe.transform(this.primaryTech.AppointmentDate, "MM/dd/yyyy");
      let startTime = "00:00:00";
      if (this.primaryTech.StartTime != null) {
        startTime = this.primaryTech.StartTime;
        this.primaryTech.StartTime = this.datePipe.transform(new Date(promisedDt + " " + this.primaryTech.StartTime), "hh:mm a");
        if (this.primaryTech.EndTime != null) {
          let startTimeDt = new Date(promisedDt + " " + this.primaryTech.StartTime);
          let endTimeDt = new Date(promisedDt + " " + this.primaryTech.EndTime);
          let timeDiff = endTimeDt.getTime() -startTimeDt.getTime();
          let min = Math.floor((timeDiff%3600000)/60000);
          this.primaryTech.EndTime = Math.floor(timeDiff/3600000) + "h : ";
          this.primaryTech.EndTime += (min==0)?"00 m":min + "m";
        }
      }
      this.primaryTech.AppointmentDate = new Date(promisedDt + " " + startTime); 
    } else {
      let durationArray= ['0','00','00'];
      if(!CommonMethods.CheckNullOrUndefined(this.details.Duration))
        durationArray = this.details.Duration.split(':');

      let endtime=durationArray[0]+"h : ";
      endtime+= (durationArray[1].toString()=='00' || durationArray[1].toString()=='0')?"00 m":durationArray[1] + "m";
      this.primaryTech = Object.assign({}, {
        User: null,
        StartTime: null,
        EndTime:endtime,
        AppointmentDate: new Date(this.details.PromisedDate)
      });
    }

    //Helpers
    let helperCodeTypeId =  appointmentTypes.find(x=> x.Code == 'Helper').ID;
    this.helpers = this.details.UserAppointments.filter(x => x.AppointmentTypeID == helperCodeTypeId);

    this.helpers.forEach(element => {
      let appointmentDate = this.datePipe.transform(element.AppointmentDate, "MM/dd/yyyy");
      let startTime = "00:00:00";
      if (element.StartTime != null) {
        startTime = element.StartTime;
        element.EndTimeObject = element.EndTime;
          element.StartTimeObject = element.StartTime;
        element.StartTime = this.datePipe.transform(new Date(appointmentDate + " " + element.StartTime), "hh:mm a");
        if (element.EndTime != null) {
          let startTimeDt = new Date(appointmentDate + " " + element.StartTime);
          let endTimeDt = new Date(appointmentDate + " " + element.EndTime);
          let timeDiff = endTimeDt.getTime() -startTimeDt.getTime();
          let min = Math.floor((timeDiff%3600000)/60000);
          element.EndTime = Math.floor(timeDiff/3600000) + "h : ";
          element.EndTime += (min==0)?"00 m":min + "m";
        }
      }
      element.AppointmentDate = new Date(appointmentDate + " " + startTime); 

      element.Priority= this.details.Priority;
      element.PromisedTime= this.details.PromisedTime;
      element.Status = this.commonMethods.GetHelperStatus(element.StatusID, element.SubStatusID);
      element.IsDispatchingAllowed = (element.Status.Code == 'assigned') ? true : false;
      element.IsUndoDispatchingAllowed = (element.Status.Code == 'dispatched') ? true : false;
    });

    let totalAgreementPrice = 0;
    let totalStandardPrice = 0;
    if (
      this.details.WorkTicketPriceBookItems != null &&
      this.details.WorkTicketPriceBookItems != undefined
    ) {
      this.details.WorkTicketPriceBookItems.forEach((x, i) => {
        if (x.AgreementPrice != null && x.Price == x.OriginalPrice) {
          x.Price = x.AgreementPrice;
          totalAgreementPrice += (x.Quantity * x.AgreementPrice);     
          totalStandardPrice += (x.Quantity * x.OriginalPrice);
        }

        x.PriceBookItem.ImagePath = this.commonMethods.GetProductDefaultImg(x.PriceBookItem);
        if (this.permissionPipe.transform(ActionName.AddServiceAgreement)
            && x.PriceBookItem.Type == "Agreement" && this.createAgreementAlertIdx < 0 && !isTabRefresh)
          this.createAgreementAlertIdx = (x.ServiceAgreementCreated == null)? i : -1;
      });
    }
    this.agreementDiscount = totalStandardPrice - totalAgreementPrice;
    this.workTicketItems = this.details.WorkTicketItems;
    this.invoiceNumber =
      this.details.WorkTicketPayment != null &&
      this.details.WorkTicketPayment.InvoiceNumber != null
        ? this.details.WorkTicketPayment.InvoiceNumber
        : null;
    this.invoiceDate =
      this.details.WorkTicketPayment != null &&
      this.details.WorkTicketPayment.InvoiceDate != null
        ? this.details.WorkTicketPayment.InvoiceDate
        : null;
    
    this.GetDiscountedAmount();
    this.GetStatusList();
    if (this.qbVersion == "none")
      this.reviewedBy =
        CommonMethods.CheckNullOrUndefined(this.details.ReviewedBy, false) ? "-" : this.details.ReviewedBy;
    this.GetPostingHistory();
    this.CheckPosttoAccounting();
    this.GetTotalPaidDetails();
    this.GetAPBItems();
    this.GetPBItems();
  }
  private CheckPosttoAccounting() {
    let status = this.details.Status.Code.toLowerCase();
    let subStatus = this.details.SubStatus.Code.toLowerCase();
    let approvedItems: any = [];

    if (status != undefined || status != null) status = status.toLowerCase();
    if (subStatus != undefined || subStatus != null)
      subStatus = subStatus.toLowerCase();

    if (
      status == Constants.WOStaticStatus().completed &&
      subStatus == Constants.WOStaticStatus().readyforreview &&
      this.invoiceDate != null &&
      this.invoiceNumber == null &&
      this.refrenceNo == "-"
    ) {
      this.enablePostToAccounting = true;
    }

    if (this.qbVersion != "none") {
      if (this.enablePostToAccounting) {
        approvedItems = this.details.WorkTicketPriceBookItems.filter(
          x => x.Status.Code.toLowerCase() == Constants.WOStaticStatus().approved
        );
        approvedItems.forEach(x => {
          if (x.PriceBookAccountingCode == null && this.enablePostToAccounting) {
            this.enablePostToAccounting = false;
          }
        });
      }
    }
  }
  private GetDiscountedAmount() {
    if (this.details.WorkTicketPayment == null) {
      // this.totalAmount = 0;
      this.workTicketPayment.TotalAmount = 0;
      
      //this.balanceOwed = 0;
      this.workTicketPayment.BalanceOwed = 0;

      //this.discountAmount = 0;
      this.workTicketPayment.DiscountAmount = 0;
      return;
    }
    // this.discountAmount = this.details.WorkTicketPayment.TotalDiscount;
    this.workTicketPayment.DiscountAmount = this.details.WorkTicketPayment.TotalDiscount;

    this.workTicketPayment.TotalApproved = this.details.WorkTicketPayment.TotalApprovedPrice;
    this.workTicketPayment.TotalApproved = this.workTicketPayment.TotalApproved.roundTo(2);//rounding

    this.workTicketPayment.NetTaxable = this.details.WorkTicketPayment.NetTaxable;
    this.workTicketPayment.TaxedAmount = this.details.WorkTicketPayment.TaxedAmount;//this.details.WorkTicketPayment.NewTaxedAmount;
    this.workTicketPayment.TotalPaid = this.details.WorkTicketPayment.TotalPaid;

    //this.totalAmount =
    this.workTicketPayment.TotalAmount = this.workTicketPayment.TotalApproved   //this.details.WorkTicketPayment.TotalApprovedPrice 
    + this.workTicketPayment.TaxedAmount            //this.details.WorkTicketPayment.NewTaxedAmount 
    - this.workTicketPayment.DiscountAmount;        //this.discountAmount;

    //this.balanceOwed = this.totalAmount - this.details.WorkTicketPayment.TotalPaid;
    this.workTicketPayment.BalanceOwed = this.workTicketPayment.TotalAmount - this.workTicketPayment.TotalPaid;

    //this.minAmount = this.math.min(this.balanceOwed, this.maxValidAmount);
    this.minAmount = this.math.min(this.workTicketPayment.BalanceOwed>0?this.workTicketPayment.BalanceOwed:0.01, this.maxValidAmount);
    this.minAmount = this.minAmount.roundTo(2);// round to 2 place of decimal

    this.paymentDisabled = this.workTicketPayment.BalanceOwed <=0 && this.fromSubStatus == Constants.WOStaticStatus().posted ? true : false;
  }
  private SortFunc(data) {
    data.sort(function(a, b) {
      return (
        new Date(a.SubmittedDate).getTime() -
        new Date(b.SubmittedDate).getTime()
      );
    });
    return data;
  }

  private GetPostingHistory() {
    if (CommonMethods.CheckNullOrUndefined(this.details.PostingHistory) 
        || CommonMethods.CheckNullOrUndefined(this.details.PostingHistory))
      this.postingHistory = { data: [], total: 0 };
    else {
      this.postingHistory = {
        data: this.details.PostingHistory,
        total: this.details.PostingHistory.length
      };
      let invoiceHistory = this.details.PostingHistory.filter(
        x => x.EntityName == "Invoice"
      );
      if (invoiceHistory.length > 0) {        
        this.reviewedBy = invoiceHistory[0].SubmittedBy;
        this.refrenceNo = invoiceHistory[0].Status;
      }
    }
  }
  private GetAPBItems() {
    if (this.details != null)
      this.approvedPBItems = {
        data: this.details.WorkTicketPriceBookItems.filter(
          x => x.Status.Code.toLowerCase() == Constants.WOStaticStatus().approved
        ),
        total: this.details.WorkTicketPriceBookItems.length
      };
    else this.approvedPBItems = { data: [], total: 0 };
  }
  private GetPBItems() {
    if (this.details != null)
      this.pricebookItems = {
        data: this.details.WorkTicketPriceBookItems,
        total: this.details.WorkTicketPriceBookItems.length
      };
    else this.pricebookItems = { data: [], total: 0 };
  }
  private GetTotalPaidDetails() {
    if (
      this.details != null &&
      this.details.WorkTicketPayment != null &&
      this.details.WorkTicketPayment.WorkTicketPaidDetails != null
    ) {
      this.details.WorkTicketPayment.WorkTicketPaidDetails.forEach(x => {
        x.IsDeletePaymentAllowed =
          this.details.PostingHistory.filter(
            y =>
              y.EntityName == "Payment" &&
              y.OriginID == x.ID &&
              y.Status != "Failure"
          ).length > 0
            ? false
            : true;
      });
      this.workTicketPaidDetails = {
        data: this.details.WorkTicketPayment.WorkTicketPaidDetails,
        total: this.details.WorkTicketPayment.WorkTicketPaidDetails.length
      };
    } else {
      this.workTicketPaidDetails = { data: [], total: 0 };
    }
  }
  private ChangeStatusApi() {
    let data = {
      ID: this.details.ID,
      CancellationComment: "",
      WorkTicketStatusAction: "",
      CancellationReason: null,
      CancellationReasonId: CommonMethods.GetID(),
      VoidComment: "",
      VoidReason: null,
      VoidReasonId: CommonMethods.GetID(),
      JobSite: { ID: this.details.JobSite.ID },
      Customer: { ID: this.details.Customer.ID },
      Status: {},
      SubStatus: {}
    };
    let StatusID = "";
    let SubStatusID = "";
    let toStatus = "";
    this.showspinner.showloader(this.viewContainerRef, this.tabCounter);
    if (this.confirmActionOkBtn == Constants.WOStaticStatus().completeWithWarning) {
      StatusID = this.initialData.CodeTypeData.WorkTicketStatus.find(
        x => x.Code.toLowerCase() == Constants.WOStaticStatus().completed
      ).ID;
      SubStatusID = this.initialData.CodeTypeData.WorkTicketSubStatus.find(
        x => x.Code.toLowerCase() == Constants.WOStaticStatus().readyforreview
      ).ID;
      toStatus = Constants.WOStaticStatus().completed;
      data.WorkTicketStatusAction = Constants.WOStaticStatus().Complete;
      data.Status = { ID: StatusID };
      data.SubStatus = { ID: SubStatusID };
    } else if (this.confirmActionOkBtn == "Cancel Work Order Review") {
      StatusID = this.initialData.CodeTypeData.WorkTicketStatus.find(
        x => x.Code.toLowerCase() == Constants.WOStaticStatus().cancelled
      ).ID;
      SubStatusID = this.details.SubStatus.ID;
      toStatus = Constants.WOStaticStatus().cancelled;
      data.WorkTicketStatusAction = Constants.WOStaticStatus().Cancel;
      data.Status = { ID: StatusID };
      data.SubStatus = { ID: SubStatusID };
      data.CancellationReason = {
        ID: this.cancelationFormGroup.controls["CancellationReason"].value
      };
      data.CancellationReasonId = this.cancelationFormGroup.controls["CancellationReason"].value
      data.CancellationComment = this.cancelationFormGroup.controls[
        "CancellationComment"
      ].value;
    } else if (this.confirmActionOkBtn == "Void Work Order Review") {
      StatusID = this.initialData.CodeTypeData.WorkTicketStatus.find(
        x => x.Code.toLowerCase() == Constants.WOStaticStatus().void
      ).ID;
      SubStatusID = this.details.SubStatus.ID;
      toStatus = Constants.WOStaticStatus().void;
      data.WorkTicketStatusAction = Constants.WOStaticStatus().Void;
      data.Status = { ID: StatusID };
      data.SubStatus = { ID: SubStatusID };
      data.VoidReason = { ID: this.voidFormGroup.controls["VoidReason"].value };
      data.VoidReasonId = this.voidFormGroup.controls["VoidReason"].value;
      data.VoidComment = this.voidFormGroup.controls["VoidComment"].value;
    } else if (this.confirmActionOkBtn ==Constants.WOStaticStatus().DispatchWorkOrder) {
      StatusID = this.initialData.CodeTypeData.WorkTicketStatus.find(
        x => x.Code.toLowerCase() == Constants.WOStaticStatus().open
      ).ID;
      SubStatusID = this.initialData.CodeTypeData.WorkTicketSubStatus.find(
        x => x.Code.toLowerCase() == Constants.WOStaticStatus().dispatched
      ).ID;
      toStatus = Constants.WOStaticStatus().dispatched;
      data.WorkTicketStatusAction = Constants.WOStaticStatus().Dispatch;
      data.Status = { ID: StatusID };
      data.SubStatus = { ID: SubStatusID };
    } else if (this.confirmActionOkBtn == Constants.WOStaticStatus().RescheduleWorkOrder) {
      StatusID = this.initialData.CodeTypeData.WorkTicketStatus.find(
        x => x.Code.toLowerCase() == Constants.WOStaticStatus().actionrequired
      ).ID;
      SubStatusID = this.initialData.CodeTypeData.WorkTicketSubStatus.find(
        x => x.Code.toLowerCase() == Constants.WOStaticStatus().rescheduled
      ).ID;
      toStatus = Constants.WOStaticStatus().rescheduled;
      data.WorkTicketStatusAction = Constants.WOStaticStatus().Reschedule;
      data.Status = { ID: StatusID };
      data.SubStatus = { ID: SubStatusID };
    } else if (this.confirmActionOkBtn == Constants.WOStaticStatus().RemoveTechnician) {
      StatusID = this.initialData.CodeTypeData.WorkTicketStatus.find(
        x => x.Code.toLowerCase() == Constants.WOStaticStatus().open
      ).ID;
      SubStatusID = this.initialData.CodeTypeData.WorkTicketSubStatus.find(
        x => x.Code.toLowerCase() == Constants.WOStaticStatus().unassigned
      ).ID;
      toStatus = Constants.WOStaticStatus().unassigned;
      data.WorkTicketStatusAction = Constants.WOStaticStatus().Unassign;
      data.Status = { ID: StatusID };
      data.SubStatus = { ID: SubStatusID };
    } else if (this.confirmActionOkBtn == Constants.WOStaticStatus().SameTechnician) {
      StatusID = this.initialData.CodeTypeData.WorkTicketStatus.find(
        x => x.Code.toLowerCase() == Constants.WOStaticStatus().open
      ).ID;
      SubStatusID = this.initialData.CodeTypeData.WorkTicketSubStatus.find(
        x => x.Code.toLowerCase() == Constants.WOStaticStatus().assigned
      ).ID;
      toStatus = Constants.WOStaticStatus().assigned;
      data.WorkTicketStatusAction =Constants.WOStaticStatus().Assign;
      data.Status = { ID: StatusID };
      data.SubStatus = { ID: SubStatusID };
    } else if (this.confirmActionOkBtn == Constants.WOStaticStatus().ContinuewithWorkOrder) {
      StatusID = this.initialData.CodeTypeData.WorkTicketStatus.find(
        x => x.Code.toLowerCase() == Constants.WOStaticStatus().open
      ).ID;
      SubStatusID = this.initialData.CodeTypeData.WorkTicketSubStatus.find(
        x => x.Code.toLowerCase() == Constants.WOStaticStatus().unassigned
      ).ID;
      toStatus = Constants.WOStaticStatus().unassigned;
      data.WorkTicketStatusAction = Constants.WOStaticStatus().Continue;
      data.Status = { ID: StatusID };
      data.SubStatus = { ID: SubStatusID };
    } else if (this.confirmActionOkBtn == Constants.WOStaticStatus().PostWorkOrder){
      StatusID = this.initialData.CodeTypeData.WorkTicketStatus.find(
        x => x.Code.toLowerCase() == Constants.WOStaticStatus().completed
      ).ID;
      SubStatusID = this.initialData.CodeTypeData.WorkTicketSubStatus.find(
        x => x.Code.toLowerCase() == Constants.WOStaticStatus().posted
      ).ID;      
      data.WorkTicketStatusAction = "None";
      data.Status = { ID: StatusID };
      data.SubStatus = { ID: SubStatusID };
    }
    this.httpService.ChangeStatus(data).subscribe(
      response => {
        this.showspinner.hideLoader(this.viewContainerRef, this.tabCounter);
        if (
          this.confirmActionOkBtn == Constants.WOStaticStatus().SameTechnician &&
          this.fromStatus == Constants.WOStaticStatus().open &&
          this.fromSubStatus == Constants.WOStaticStatus().dispatched
        ) {
          this.toastr.success(
            Constants.DefaultWorkOrderMessages.WorkOrderRecalledMessage,
            "Success!"
          );
        } else if (
          this.confirmActionOkBtn == Constants.WOStaticStatus().RemoveTechnician &&
          this.fromStatus == Constants.WOStaticStatus().open &&
          this.fromSubStatus == Constants.WOStaticStatus().dispatched
        ) {
          this.toastr.success(
            Constants.DefaultWorkOrderMessages
              .WorkOrderRecalledandUnAssignedMessage,
            "Success!"
          );
        } else if (
          this.confirmActionOkBtn == Constants.WOStaticStatus().SameTechnician &&
          this.fromStatus == Constants.WOStaticStatus().actionrequired &&
          this.fromSubStatus == Constants.WOStaticStatus().rescheduled
        ) {
          this.toastr.success(
            Constants.DefaultWorkOrderMessages.WorkOrderOpenMessage,
            "Success!"
          );
        } else if (
          this.confirmActionOkBtn == Constants.WOStaticStatus().RemoveTechnician &&
          this.fromStatus == Constants.WOStaticStatus().actionrequired &&
          this.fromSubStatus == Constants.WOStaticStatus().rescheduled
        ) {
          this.toastr.success(
            Constants.DefaultWorkOrderMessages
              .WorkOrderOpenandTechnicianMessage,
            "Success!"
          );
        }  else if (
          this.confirmActionOkBtn == Constants.WOStaticStatus().PostWorkOrder          
        ) {
          this.toastr.success(Constants.DefaultWorkOrderMessages.WorkOrderPostedWithoutIntegrationMessage, "Success!");
          this.enablePostToAccounting = false; // Online&Desktop takes some time to reflect changes but not None. Calling Get will override this change
        } else {
          let WorkOrderMessage: string =
            toStatus == Constants.WOStaticStatus().unassigned
              ? Constants.DefaultWorkOrderMessages.WorkOrderUnAssignedMessage
              : toStatus == Constants.WOStaticStatus().assigned
              ? Constants.DefaultWorkOrderMessages.WorkOrderAssignedMessage
              : toStatus == Constants.WOStaticStatus().rescheduled
              ? Constants.DefaultWorkOrderMessages.WorkOrderResheduledMessage
              : toStatus == Constants.WOStaticStatus().dispatched
              ? Constants.DefaultWorkOrderMessages.WorkOrderDispatchedMessage
              : toStatus == Constants.WOStaticStatus().void
              ? Constants.DefaultWorkOrderMessages.WorkOrderVoidedMessage
              : toStatus == Constants.WOStaticStatus().cancelled
              ? Constants.DefaultWorkOrderMessages.WorkOrderCancelledMessage
              : toStatus == Constants.WOStaticStatus().completed
              ? Constants.DefaultWorkOrderMessages.WorkOrderCompletedMessage
              : "";
          this.toastr.success(WorkOrderMessage, "Success!");
        }
        this.dataSharing.WOSChangeEvent({ destination: WOSChangeEventDestination.WOReviewLanding, response: response });
        if (toStatus == Constants.WOStaticStatus().completed) {
          this.tabOpen.DestroyTab(this.tabCounter);

          this.tabOpen.OpenTab({
            tabId: Tabs.FsLiteWorkOrderReview,
            params: {},
            tabTitle: "Work Order Review"
          });
        }
        
        this.details = response;
        this.confirmationBox = false;
        this.cancelReasonPopup = false;
        this.voidTicketPopup = false;
        this.confirmMessage = "";
        this.isError = false;
        this.confirmActionCancelBtn = "";
        if (data.WorkTicketStatusAction == Constants.WOStaticStatus().Unassign || (data.WorkTicketStatusAction == "None" && this.qbVersion == "none")) {
          this.GetWorkOrderReviewDetails();
        } else {
          this.GetStatusList();
        }
      },
      error => {
        this.showspinner.hideLoader(this.viewContainerRef, this.tabCounter);
        this.confirmationBox = false;
        this.confirmMessage = "";
        this.isError = false;
        this.confirmActionCancelBtn = "";
        if (!CommonMethods.CheckNullOrUndefined(error.error))
          this.toastr.showMultiLineError(error.error.Message, "Error");
      }
    );
  }
  private GetStatusList() {
    this.paymentDisabled = false; // by default payment option is set to enabled
    let StatusList = [];
    const technician = !FsUtil.checkNullOrUndefined([this.primaryTech])? this.primaryTech.User : null;
    if (
      this.details.Status.Code.toLowerCase() == Constants.WOStaticStatus().completed &&
      this.details.SubStatus.Code.toLowerCase() == Constants.WOStaticStatus().readyforreview
    ) {
      StatusList.push({ menu: Constants.WOStaticStatus().RescheduleWorkOrder, submenu: [] });
      StatusList.push({ menu: Constants.WOStaticStatus().CancelWorkOrder, submenu: [] });
      StatusList.push({ menu: Constants.WOStaticStatus().VoidWorkOrder, submenu: [] });
    } else if (
      this.details.Status.Code.toLowerCase() == Constants.WOStaticStatus().actionrequired &&
      this.details.SubStatus.Code.toLowerCase() == Constants.WOStaticStatus().rescheduled
    ) {
      if (technician)
        StatusList.push({
          menu: Constants.WOStaticStatus().ContinuewithWorkOrder,
          submenu: [Constants.WOStaticStatus().SameTechnician, Constants.WOStaticStatus().RemoveTechnician]
        });
      else
        StatusList.push({
          menu: Constants.WOStaticStatus().ContinuewithWorkOrder,
          submenu: []
        });
      StatusList.push({ menu: Constants.WOStaticStatus().CompleteWorkOrder, submenu: [] });
      StatusList.push({ menu: Constants.WOStaticStatus().CancelWorkOrder, submenu: [] });
      StatusList.push({ menu: Constants.WOStaticStatus().VoidWorkOrder, submenu: [] });
    } else if (
      this.details.Status.Code.toLowerCase() == Constants.WOStaticStatus().actionrequired &&
      this.details.SubStatus.Code.toLowerCase() == Constants.WOStaticStatus().partsneeded
    ) {
      if (technician) {
        StatusList.push({
          menu: Constants.WOStaticStatus().ContinuewithWorkOrder,
          submenu: [Constants.WOStaticStatus().SameTechnician, Constants.WOStaticStatus().RemoveTechnician]
        });
      } else {
        StatusList.push({
          menu: Constants.WOStaticStatus().ContinuewithWorkOrder,
          submenu: []
        });
      }
      StatusList.push({ menu: Constants.WOStaticStatus().CompleteWorkOrder, submenu: [] });
      StatusList.push({ menu: Constants.WOStaticStatus().CancelWorkOrder, submenu: [] });
      StatusList.push({ menu: Constants.WOStaticStatus().VoidWorkOrder, submenu: [] });
    } else {
      this.editDisabled = this.commonMethods.IsWorkOrderEditDisabled(this.details);
    }
    this.statusList = StatusList;
    setTimeout(() => {
      var button = $(".dropdown-submenu button.test");
      button.unbind("click");
      $(".dropdown-submenu button.test").click(function(e) {
        $(this)
          .next("ul")
          .toggle();
        e.stopPropagation();
        e.preventDefault();
      });

      $('[data-toggle="dropdown"]').click(function() {
        $(this)
          .siblings(".dropdown-menu")
          .find(".dropdown-menu")
          .hide();
      });
    }, 100);
  }
  private PostWorkTicketIntegration() {
    this.showspinner.showloader(this.viewContainerRef, this.tabCounter);
    this.accountingLogService
      .PostIntegration({ EntityID: this.details.ID, EntityName: "Invoice" })
      .subscribe(
        response => {
          if (response != null) {
            this.showspinner.hideLoader(this.viewContainerRef, this.tabCounter);
            this.toastr.success("Posted to accounting");
          }
        },
        error => {
          this.showspinner.hideLoader(this.viewContainerRef, this.tabCounter);
          this.showPostingToAccResult = true;
          if (!CommonMethods.CheckNullOrUndefined(error.error))
            this.toastr.showMultiLineError(error.error.Message, "Error");
        }
      );
  }

  private PostWOWithoutIntegration() {
    this.confirmActionOkBtn = Constants.WOStaticStatus().PostWorkOrder;
    this.ChangeStatusApi();
  }

  /** Hide and clear confirmation box values */
  private HideAndClearConfimBox() {
    this.confirmationBox = false;
    this.confirmMessage = "";
    this.isError = false;
    this.confirmActionCancelBtn = "";
    this.createAgreementAlertIdx = -1;
  }
  // #endregion

  // #region  Public Methods
  public GetDayOfWeek(date) {
    return Constants.GetDayOfWeek(date);
  }
  public tabContentClick()
  {
    // close window of current tab
    this.closeEquipmentLink();
  }  
  public showEquipmentLinks(event,itemData)
  {
    event.stopPropagation();
    this.commonMethods.setKendoWindowPosition(event, this.EquipmentDialogueData);
    this.closeEquipmentLink();
    this.EquipmentDialogueData.Description = itemData.Description;
    this.EquipmentDialogueData.WorkTicketPriceBookItemEquipments = itemData.WorkTicketPriceBookItemEquipments;
    this.isEquipmentLinkOpened = true;
  }
  public closeEquipmentLink()
  {
    this.isEquipmentLinkOpened=false;
  }
  public RefreshTab(instantSpinnerTime: number = Constants.defaultSpinnertimeout)
  {
    this.enablePostToAccounting = false;
    this.statusList = [];
    this.InitializeForm(instantSpinnerTime, true);
  }
  public Toggle__collapse(trg) {
    var parent = $(trg);
    parent.toggleClass("hidden");
    parent.find(".collapse__box__body").slideToggle();
  }
  public EditWorkOrder() {
    this.tabOpen.ReplaceTab({
      CurrentTabIndex: this.tabCounter,
      newTabInfo: {
        tabId: Tabs.FsLiteWorkOrderReviewEdit,
        params: {
          ID: this.details.ID,
          jobsiteId: this.details.JobSite.ID,
          customerId: this.details.Customer.ID,
          activeSubTabIndex: this.activeSubTabIndex
        },
        tabTitle: this.details.WorkTicketNo
      }
    });
  }  
  public OnTabSelect(data) {
    this.activeSubTabIndex = data["index"];
  }
  public ConfirmAction(val) {
    if(this.createAgreementAlertIdx > -1 && val) {
      this.activeSubTabIndex = 1;
      let idx = this.createAgreementAlertIdx;
      this.HideAndClearConfimBox();
      setTimeout(() => {
        let rows = $('#itemsGrid').find('.k-grid-table>tbody>tr');
        if (rows.length > 0){
          $(".main__content_section").animate({ scrollTop: ($(rows[idx]).offset().top - 70) }, 1000); // Header-Top:60
        }
      }, 5);
    } else { 
      if (val) {
        this.ChangeStatusApi();
      } else {
        this.HideAndClearConfimBox();
      }
    }
  }
  public CancelOrder() {
    if (this.cancelationFormGroup.valid) {
      this.confirmActionOkBtn = "Cancel Work Order Review";
      this.ChangeStatusApi();
    } else {
      this.commonMethods.markFormGroupTouched(this.cancelationFormGroup);
    }
  }
  public VoidOrder() {
    if (this.voidFormGroup.valid) {
      this.confirmActionOkBtn = "Void Work Order Review";
      this.ChangeStatusApi();
    } else {
      this.commonMethods.markFormGroupTouched(this.voidFormGroup);
    }
  }
  public CloseCancelReasonPopup() {
    this.cancelReasonPopup = false;
  }
  public CloseVoidReasonPopup() {
    this.voidTicketPopup = false;
  }
  public ChangeStatus(toStatus) {
    if (toStatus == Constants.WOStaticStatus().CompleteWorkOrder) {
      if (
        this.details.WorkTicketPriceBookItems.filter(
          x => x.Status.Code.toLowerCase() == Constants.WOStaticStatus().approved && x.WorkStatus == null
        ).length > 0
      ) {
        this.confirmationBox = true;
        this.confirmMessage =
          "All APPROVED line items must have a Work Status.";
        this.isError = true;
        this.confirmActionCancelBtn = "Ok";
        return;
      }
      if (
        this.details.WorkTicketPayment == null ||
        ((this.details.WorkTicketPayment.CustomerSignImg == null ||
          this.details.WorkTicketPayment.CustomerSignImg == "") &&
          (this.details.WorkTicketPayment.TechnicianSignImg == null ||
            this.details.WorkTicketPayment.CustomerSignImg == ""))
      ) {
        this.confirmMessage = "Technician and Customer Signatures are missing.";
      } else if (
        this.details.WorkTicketPayment.CustomerSignImg == null ||
        this.details.WorkTicketPayment.CustomerSignImg == ""
      ) {
        this.confirmMessage = "Customer Signature is missing.";
      } else if (
        this.details.WorkTicketPayment.TechnicianSignImg == null ||
        this.details.WorkTicketPayment.TechnicianSignImg == ""
      ) {
        this.confirmMessage = "Technician Signature is missing.";
      }
      
      if (this.workTicketPayment.BalanceOwed > 0) { //if (this.balanceOwed > 0) {
        this.confirmMessage =
          this.confirmMessage +
          " <br>There is still a Balance Due on this Work Order.";
      }
      this.isError = false;
      this.confirmationBox = true;
      this.confirmActionOkBtn = Constants.WOStaticStatus().completeWithWarning;
      this.confirmActionCancelBtn = "Ok";
      if (this.confirmMessage != "") {
        return;
      } else {
        this.ChangeStatusApi();
      }
    } else if (toStatus == Constants.WOStaticStatus().CancelWorkOrder) {
      if (
        this.details.WorkTicketPriceBookItems.filter(
          x => (x.Status.Code.toLowerCase() == Constants.WOStaticStatus().approved && x.Total !=0 )
        ).length > 0
      ) {
        //dollar value validation
        this.confirmationBox = true;
        this.confirmMessage =
          "Work Order has a dollar value; Cancelling is not allowed";
        this.isError = true;
        this.confirmActionCancelBtn = "Ok";
        return;
      } else {
        this.IntializeCancelationFrom();
        this.cancelReasonPopup = true;
      }
    } else if (toStatus == Constants.WOStaticStatus().VoidWorkOrder) {
      if (
        this.details.WorkTicketPriceBookItems.filter(
          x => (x.Status.Code.toLowerCase() == Constants.WOStaticStatus().approved && x.Price !=0 )
        ).length > 0
      ) {
        //dollar value validation
        this.confirmationBox = true;
        this.confirmMessage =
          "Work Order has a dollar value; Voiding is not allowed";
        this.isError = true;
        this.confirmActionCancelBtn = "Ok";
        return;
      } else {
        this.IntializeVoidFrom();
        this.voidTicketPopup = true;
      }
    } else if (toStatus ==Constants.WOStaticStatus().DispatchWorkOrder) {
      this.confirmActionOkBtn =Constants.WOStaticStatus().DispatchWorkOrder;
      this.ChangeStatusApi();
    } else if (toStatus == Constants.WOStaticStatus().RemoveTechnician) {
      this.confirmActionOkBtn = Constants.WOStaticStatus().RemoveTechnician;
      this.ChangeStatusApi();
    } else if (toStatus == Constants.WOStaticStatus().ContinuewithWorkOrder) {
      this.confirmActionOkBtn = Constants.WOStaticStatus().ContinuewithWorkOrder;
      this.ChangeStatusApi();
    } else if (toStatus == Constants.WOStaticStatus().SameTechnician) {
      this.confirmActionOkBtn = Constants.WOStaticStatus().SameTechnician;
      this.ChangeStatusApi();
    } else if (toStatus == Constants.WOStaticStatus().RescheduleWorkOrder) {
      this.confirmActionOkBtn = Constants.WOStaticStatus().RescheduleWorkOrder;
      this.ChangeStatusApi();
    }
  }
    public Print(printtype: string) {
    this.toastr.clear();
    this.showspinner.showloader(this.viewContainerRef, this.tabCounter);
    this.httpService.Print(this.inputParams.ID, printtype).subscribe(response => {
      this.printService.PrintURL(this.commonMethods.GetDocumentPrintURL(response));
      this.showspinner.hideLoader(this.viewContainerRef, this.tabCounter);
    },
      error => {
        this.showspinner.hideLoader(this.viewContainerRef, this.tabCounter);
        this.toastr.showMultiLineError(error.error.Message, "Error");
      }
    );    
  }
  public AcceptPostingResult() {
    this.showPostingToAccResult = false;
  }
  
  public PostWorkTicket(hasNoneIntegration) {
    if(hasNoneIntegration)
      this.PostWOWithoutIntegration();
    else
      this.PostWorkTicketIntegration();
  }
  public RePostIntegration(dataItem) {
    this.showspinner.showloader(this.viewContainerRef, this.tabCounter);
    this.accountingLogService
      .PostIntegration({
        EntityID: dataItem.OriginID,
        EntityName: dataItem.EntityName
      })
      .subscribe(
        response => {
          if (response != null) {
            this.showspinner.hideLoader(this.viewContainerRef, this.tabCounter);
            this.toastr.success("Posted to accounting");
          }
        },
        error => {
            this.showspinner.hideLoader(this.viewContainerRef, this.tabCounter);
          if (!CommonMethods.CheckNullOrUndefined(error.error))
            this.toastr.showMultiLineError(error.error.Message, "Error");
        }
      );
  }

  public DispatchHelper(data: { dataItem: any, IsDispatch: boolean }) {
    let dataItem = data.dataItem;
    let IsDispatch = data.IsDispatch;
     this.showspinner.showloader(this.viewContainerRef, this.tabCounter);
    let submittedModel = this.commonMethods.GetAppointmentModel(dataItem,IsDispatch,this.initialData);
    this.helperService.Put_Dispatch_Appointment(submittedModel).subscribe(
		  (response) => {
        this.showspinner.hideLoader(this.viewContainerRef, this.tabCounter);
        if(IsDispatch)
          this.toastr.success(Constants.DefaultWorkOrderMessages.HelperDispatchedMessage, "Success");
        else
          this.toastr.success(Constants.DefaultWorkOrderMessages.HelperUndoDispatchedMessage, "Success");
        this.GetWorkOrderReviewDetails();        
      }, error => {
        this.showspinner.hideLoader(this.viewContainerRef, this.tabCounter);
        if (!CommonMethods.CheckNullOrUndefined(error.error))
          this.toastr.showMultiLineError(error.error.Message, "Error");
      });         
  }

  
  public OnExpand() {
    $(document).on("click", ".k-hierarchy-cell>a", function() {
      $(this)
        .parents(".k-master-row")
        .addClass("active");
    });
  }
  public OnCollapse() {
    $(document).on("click", ".k-hierarchy-cell>a", function() {
      $(this)
        .parents(".k-master-row")
        .removeClass("active");
    });
  }
 
  public ResetTabContentChanged(isDirty: boolean) {
    this.tabOpen.unsavedChangedDetected({
      dirty: isDirty,
      Index: this.tabCounter
    });
    this.isUnsavedTriggered = false;
    if (this.addPaymentComponent.creditCardForm != undefined && this.addPaymentComponent.creditCardForm != null) {
      this.addPaymentComponent.creditCardForm.markAsPristine();
    }
    if (this.addPaymentComponent.paymentForm != undefined && this.addPaymentComponent.paymentForm != null) {
      this.addPaymentComponent.paymentForm.markAsPristine();
    }
  }
  public PaymentUpdated(eventData) {
    this.GetDiscountedAmount();
    this.GetTotalPaidDetails();
  }

  public closeErrorModal() {
    this.errorShowModal = false;
    this.errorMessage = "";
  }
  viewEstimate(val) {
    let params = Object.assign({},val);
    params["Customer"] = { ID: params["CustomerID"] };
    params["JobSiteID"]= params.JobSite.ID;
    this.tabOpen.OpenTab({
      tabId: Tabs.EstimateDetail,
      params: params,
      tabTitle: val.EstimateNo == null ? " " : val.EstimateNo,
      replaceIfOpen: {
            replaceTab: true,
            tabToReplace: Tabs.EstimateEdit,
            action: "focus"
      }
    });
  }
  viewPBEstimate(val,customerID?: string) {
    let params = Object.assign({},val);
    params["Customer"] = { ID: customerID};
    params["JobSiteID"]= params.JobSite.ID;
    this.tabOpen.OpenTab({
      tabId: Tabs.EstimateDetail,
      params: params,
      tabTitle: val.EstimateNo == null ? " " : val.EstimateNo,
      replaceIfOpen: {
            replaceTab: true,
            tabToReplace: Tabs.EstimateEdit,
            action: "focus"
      }
    });
  }
  public CreateAgreement(item) {    
    let tabAlreadyOpened = this.tabsComponent.openedTabs.find(
		  x =>
			  x.tabId == Tabs.NewServiceAgreement &&
			  x.tabTitle == "New Service Agreement");
		    if (tabAlreadyOpened) {
            this.errorShowModal = true;
            this.popupTitle ="Warning";
            this.errorMessage = "Please complete the open new service agreement tab before proceeding with another.";
            return;
        }
    let tabObj = TabParams.NewServiceAgreement(this.details, item);
    tabObj.params["Technician"] = !FsUtil.checkNullOrUndefined([this.primaryTech, this.primaryTech.User])? this.primaryTech.User.FirstName + " " + this.primaryTech.User.LastName : "";
    this.tabOpen.OpenTab(tabObj);
  }
  viewAgreement(val) {
    this.tabOpen.OpenTab(TabParams.ViewServiceAgreement({ ID: val.ID, ServiceAgreementNumber: val.AgreementID, JobSite: { ID: this.details.JobSite.ID } }, true));
  }
  // #endregion
}

